document.addEventListener("DOMContentLoaded", function () {
  handleWhatMySizePopUp();
  setTimeout(setupBidirectionalSync, 1000);
});

// ===== Variant selection helper (add near your other helpers) =====
function selectVariantKeepingOtherOptions(sizeOptionName, newSizeValue) {
  // 1) Get product JSON from typical theme locations
  const productJsonEl =
    document.querySelector(
      'script[type="application/json"][data-product-json]'
    ) ||
    document.querySelector('script[type="application/json"].product-json') ||
    document.getElementById("ProductJson") ||
    null;

  if (!productJsonEl) {
    console.warn(
      "[WMS] Product JSON not found — cannot map options to variants."
    );
    return;
  }

  let product;
  try {
    product = JSON.parse(productJsonEl.textContent || productJsonEl.innerHTML);
  } catch (e) {
    console.warn("[WMS] Failed to parse product JSON", e);
    return;
  }

  if (
    !product ||
    !Array.isArray(product.variants) ||
    !Array.isArray(product.options)
  ) {
    console.warn("[WMS] Product JSON shape unexpected.");
    return;
  }

  // 2) Build a name->index map for options (e.g., { "Color": 0, "Frame Size": 1 })
  const optionIndexByName = {};
  product.options.forEach((optName, idx) => {
    optionIndexByName[optName] = idx; // 0-based
  });

  const sizeIdx = optionIndexByName[sizeOptionName];
  if (sizeIdx == null) {
    console.warn(`[WMS] Option "${sizeOptionName}" not present on product.`);
    return;
  }

  // 3) Read the *currently selected* options from the DOM (by option name)
  //    We assume radios live inside .ombraz-v2pdp__product-options, and inputs have value = option value.
  const root =
    document.querySelector(".ombraz-v2pdp__product-options") || document;
  const getSelectedByName = (optName) => {
    const selector = [
      `.ombraz-v2pdp__product-options [name="${optName}"]:checked`,
      `.ombraz-v2pdp__product-options input[type="radio"][name="${optName}"]:checked`,
      `[name="${optName}"]:checked`,
    ].join(", ");
    const el = root.querySelector(selector);
    return el ? el.value : null;
  };

  // Build current options array in product.options order
  const currentOptions = product.options.map((optName) =>
    getSelectedByName(optName)
  );

  // Replace only the size value
  currentOptions[sizeIdx] = newSizeValue;

  // 4) Find the matching variant using option1/2/3
  const match = product.variants.find((v) => {
    // Shopify exposes option1/option2/option3…
    const opts = [v.option1, v.option2, v.option3].filter((x) => x != null);
    return (
      opts.length === currentOptions.length &&
      opts.every(
        (val, i) => String(val).trim() === String(currentOptions[i]).trim()
      )
    );
  });

  if (!match) {
    console.warn("[WMS] No variant matches the combination:", currentOptions);
    return;
  }

  // 5) Update only what changed:
  //    - Tick the *size* radio to the new value (keeps non-size radios intact)
  //    - Update the hidden variant id input (name="id") so the add-to-cart & theme scripts stay in sync
  //    - Dispatch change on the hidden id (many themes listen to this) without forcing a full reset

  // guard re-entrancy with a shared flag if you already have one:
  window.__wmsSyncing = true;

  try {
    // Tick size radio in UI if present
    const sizeRadio = root.querySelector(
      `input[type="radio"][name="${sizeOptionName}"][value="${CSS.escape(
        newSizeValue
      )}"]`
    );
    if (sizeRadio && !sizeRadio.checked) {
      sizeRadio.checked = true;
      sizeRadio.dispatchEvent(new Event("change", { bubbles: true }));
    }

    // Ensure non-size radios reflect currentOptions (usually already true)
    product.options.forEach((optName, i) => {
      if (i === sizeIdx) return; // leave others as-is
      const wantVal = currentOptions[i];
      const current = getSelectedByName(optName);
      if (wantVal && current !== wantVal) {
        const radio = root.querySelector(
          `input[type="radio"][name="${optName}"][value="${CSS.escape(
            wantVal
          )}"]`
        );
        if (radio) {
          radio.checked = true;
          // IMPORTANT: do NOT dispatch if you know your theme re-renders on every change.
          // If needed, dispatch once below after id swap.
        }
      }
    });

    // Update the hidden variant id
    const idInput =
      root.querySelector('input[name="id"]') ||
      document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (idInput && String(idInput.value) !== String(match.id)) {
      idInput.value = match.id;
      idInput.dispatchEvent(new Event("change", { bubbles: true }));
    }

    // If your theme watches URL params for variant, update it without reload:
    if (history.replaceState && product.handle) {
      const url = new URL(window.location.href);
      url.searchParams.set("variant", match.id);
      history.replaceState({}, "", url.toString());
    }

    // Optionally update price/image sections if your theme relies on custom events
    document.dispatchEvent(
      new CustomEvent("variant:change", {
        detail: { variant: match, options: currentOptions },
      })
    );
  } finally {
    // small defer so any downstream listeners finish before we drop the guard
    setTimeout(() => {
      window.__wmsSyncing = false;
    }, 0);
  }
}

function handleWhatMySizePopUp() {
  const modal = document.querySelector(".wms-modal");
  const backdrop = document.getElementById("wmsBackdrop");
  const triggerButton = document.querySelector(".wms-trigger");
  const closeButton = document.querySelector(".wms-modal__close");
  const radioInputs = document.querySelectorAll(".wms-modal__radio-input");
  const oldSizingRadios = document.querySelectorAll(
    "#original-version fieldset:last-of-type"
  );
  const sizingOptionsDropdownRadios = document.querySelectorAll(
    ".sizing-stack__size-option input"
  );

  if (!modal || !backdrop || !triggerButton || !closeButton) {
    return;
  }

  const canSyncSizing = Boolean(
    radioInputs.length &&
      oldSizingRadios.length &&
      sizingOptionsDropdownRadios.length
  );

  // Store all focusable elements
  const getFocusableElements = () => {
    return Array.from(
      modal.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    );
  };

  // Store the element that was focused before the modal was opened
  let previouslyFocusedElement = null;

  // Get scrollbar width to compensate for layout shift
  const getScrollbarWidth = () => {
    return window.innerWidth - document.documentElement.clientWidth;
  };

  // Function to open the modal
  function openModal() {
    // Store the currently focused element to return to later
    previouslyFocusedElement = document.activeElement;

    // Remove inline styles and add active class to show the modal
    backdrop.style.opacity = "";
    backdrop.style.visibility = "";
    backdrop.style.pointerEvents = "";
    backdrop.classList.add("is-active");

    // Update ARIA attributes
    modal.setAttribute("aria-hidden", "false");
    backdrop.setAttribute("aria-hidden", "false");

    // Prevent scrolling without causing layout shift
    const scrollbarWidth = getScrollbarWidth();
    document.documentElement.style.setProperty(
      "--scrollbar-width",
      `${scrollbarWidth}px`
    );
    document.documentElement.classList.add("wms-scroll-lock");

    // Set focus on the modal
    modal.focus();

    // Add event listeners for accessibility
    document.addEventListener("keydown", handleKeyDown);

    // Prevent clicks inside modal from bubbling to backdrop
    modal.addEventListener("click", stopPropagation);
  }

  // Function to close the modal
  function closeModal() {
    backdrop.classList.remove("is-active");

    // Update ARIA attributes
    modal.setAttribute("aria-hidden", "true");
    backdrop.setAttribute("aria-hidden", "true");

    // Re-enable scrolling
    document.documentElement.classList.remove("wms-scroll-lock");

    // Remove event listeners
    document.removeEventListener("keydown", handleKeyDown);
    modal.removeEventListener("click", stopPropagation);

    // Return focus to the element that was focused before the modal was opened
    if (previouslyFocusedElement) {
      previouslyFocusedElement.focus();
    }
  }

  // Stop propagation to prevent clicks inside modal from closing it
  function stopPropagation(event) {
    event.stopPropagation();
  }

  // Handle keyboard events
  function handleKeyDown(event) {
    // Close on Escape key
    if (event.key === "Escape") {
      closeModal();
      return;
    }

    // Trap focus inside modal when Tab is pressed
    if (event.key === "Tab") {
      trapFocus(event);
    }
  }

  // Trap focus inside the modal
  function trapFocus(event) {
    const focusableElements = getFocusableElements();

    if (focusableElements.length === 0) return;

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    // If Shift+Tab on first element, move to last element
    if (event.shiftKey && document.activeElement === firstElement) {
      lastElement.focus();
      event.preventDefault();
    }
    // If Tab on last element, move to first element
    else if (!event.shiftKey && document.activeElement === lastElement) {
      firstElement.focus();
      event.preventDefault();
    }
  }

  // Event listeners
  triggerButton.addEventListener("click", openModal);
  closeButton.addEventListener("click", closeModal);

  // Close when clicking on backdrop (outside the modal)
  backdrop.addEventListener("click", (event) => {
    if (event.target === backdrop) {
      closeModal();
    }
  });

  // Handle radio button changes
  if (canSyncSizing) {
    radioInputs.forEach((input) => {
      input.addEventListener("change", (event) => {
        stopPropagation(event);

        const isSmallDevice = window.matchMedia("max-width: 980px");

        // Synchronize the radio button states
        oldSizingRadios.forEach((fieldset) => {
          if (fieldset.classList.contains("hide-this")) {
            fieldset.classList.remove("hide-this");

            if (isSmallDevice) {
              const whatMySizeContronButtonWrapper = document.querySelector(
                ".v2pdp__abtest-sizing-info"
              );

              if (whatMySizeContronButtonWrapper) {
                whatMySizeContronButtonWrapper.style.marginBlockStart =
                  "2.6rem";
              }
            }
          }

          const radio = fieldset.querySelector(
            `input[type="radio"][value="${input?.value}"]`
          );

          if (radio) {
            radio.checked = true;
            setTimeout(() => {
              radio.dispatchEvent(new Event("change", { bubbles: true }));
            }, 0);
          }
        });

        setTimeout(() => {
          closeModal();
        }, 50);

        // Synchronize the dropdown radio buttons
        setTimeout(() => {
          sizingOptionsDropdownRadios.forEach((radio) => {
            if (radio.value === input.value) {
              radio.checked = true;
              radio.dispatchEvent(new Event("change", { bubbles: true }));
            }
          });
        }, 10);
      });
    });
  }
}

function setupBidirectionalSync() {
  // Get references to both sets of radio inputs
  const wmsRadios = document.querySelectorAll(".wms-modal__radio-input");
  const productOptionRadios = document.querySelectorAll(
    ".ombraz-v2pdp__product-options input[type='radio'][name='frame-size'], " +
      ".ombraz-v2pdp__product-options input[type='radio'][name='Frame Size']"
  );

  // Flag to prevent infinite loops when syncing
  let isSyncing = false;

  // Listen for changes on WMS popup radios
  wmsRadios.forEach((radio) => {
    radio.addEventListener("change", function (_event) {
      // console.log("hey _first_listen");
      if (isSyncing) return; // Prevent infinite loop

      isSyncing = true;
      const selectedValue = this.value;
      console.log(this.value);
      console.log(productOptionRadios);
      // Update product option radios with minimal delay
      setTimeout(() => {
        productOptionRadios.forEach((optionRadio) => {
          console.log(optionRadio);
          if (optionRadio.value === selectedValue) {
            // optionRadio.checked = true;
            // // Dispatch a native change event to trigger any other listeners
            // optionRadio.dispatchEvent(new Event("change", { bubbles: true }));
            // In WMS modal -> product sync
            wmsRadios.forEach((radio) => {
              radio.addEventListener("change", function () {
                if (window.__wmsSyncing) return;
                selectVariantKeepingOtherOptions("Frame Size", this.value);
              });
            });

            // In product radios -> WMS sync (still fine), but when *size* changes, use helper:
            document.addEventListener("change", function (event) {
              if (window.__wmsSyncing) return;
              const t = event.target;
              const isSizeRadio =
                t.matches(
                  ".ombraz-v2pdp__product-options input[type='radio'][name='Frame Size']"
                ) ||
                t.matches(
                  ".ombraz-v2pdp__product-options input[type='radio'][name='frame-size']"
                );
              if (isSizeRadio) {
                selectVariantKeepingOtherOptions("Frame Size", t.value);
              }
            });
          }
        });

        // Reset flag after dispatch completes
        setTimeout(() => {
          isSyncing = false;
        }, 10);
      }, 0);
    });
  });

  // Listen for changes on product option radios using event delegation
  document.addEventListener("change", function (event) {
    // console.log("hey _listen");
    // Check if the changed element is a frame size radio in product options
    if (isSyncing) return;

    const target = event.target;
    if (
      target.matches(
        ".ombraz-v2pdp__product-options input[type='radio'][name='frame-size']"
      ) ||
      target.matches(
        ".ombraz-v2pdp__product-options input[type='radio'][name='Frame Size']"
      )
    ) {
      isSyncing = true;
      const selectedValue = target.value;

      // Update WMS popup radios with minimal delay
      setTimeout(() => {
        wmsRadios.forEach((wmsRadio) => {
          if (wmsRadio.value === selectedValue) {
            wmsRadio.checked = true;
            // Dispatch a native change event
            wmsRadio.dispatchEvent(new Event("change", { bubbles: true }));
          }
        });

        // Make the frame size fieldset visible if it's hidden
        const frameSizeFieldset = document.querySelector(
          "#original-version fieldset:last-child"
        );
        if (
          frameSizeFieldset &&
          frameSizeFieldset.classList.contains("hide-this")
        ) {
          frameSizeFieldset.classList.remove("hide-this");
        }

        // Reset flag after all updates
        setTimeout(() => {
          isSyncing = false;
        }, 10);
      }, 0);
    }
  });

  // Also sync with sizing dropdown radios if they exist
  const sizingOptionsDropdownRadios = document.querySelectorAll(
    ".sizing-stack__size-option input"
  );

  if (sizingOptionsDropdownRadios.length) {
    sizingOptionsDropdownRadios.forEach((radio) => {
      radio.addEventListener("change", function (event) {
        if (isSyncing) return;

        isSyncing = true;
        const selectedValue = this.value;

        // Update WMS popup radios with minimal delay
        setTimeout(() => {
          wmsRadios.forEach((wmsRadio) => {
            if (wmsRadio.value === selectedValue) {
              wmsRadio.checked = true;
              wmsRadio.dispatchEvent(new Event("change", { bubbles: true }));
            }
          });

          // Update product option radios
          productOptionRadios.forEach((optionRadio) => {
            if (optionRadio.value === selectedValue) {
              optionRadio.checked = true;
              optionRadio.dispatchEvent(new Event("change", { bubbles: true }));
            }
          });

          // Reset flag after all updates
          setTimeout(() => {
            isSyncing = false;
          }, 10);
        }, 0);
      });
    });
  }
}
